/* The owner registry.

   Separate from the stage-2 access list on purpose: this is who work is
   attributed to, not who may sign in. Eleven of the twenty-two rows imported
   from the tracking sheet had no owner, so "Unassigned" is a real and common
   state rather than an error to be designed out. */
import { useState } from "react";

import { api } from "../api";
import { usePermissions } from "../auth";
import { Panel } from "./ui";
import { useStore } from "../store";

export default function PeoplePanel() {
  const { people, services, assets, run } = useStore();
  const [name, setName] = useState("");
  const { canDelete } = usePermissions();

  const unassigned = [...services, ...assets].filter((o) => !o.owner_id).length;

  return (
    <Panel title="People" aside={<span className="muted">{people.length}</span>}>
      {unassigned > 0 && (
        <p className="note">
          {unassigned} service(s) and asset(s) have no owner. They are shown as Unassigned
          everywhere, and in stage 2 nobody but an admin will be able to edit them.
        </p>
      )}
      <div className="tablewrap">
        <table>
          <thead>
            <tr>
              <th className="left">Name</th>
              <th className="left">Email</th>
              <th>Services</th>
              <th>Assets</th>
              <th>Tasks</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {people.map((p) => (
              <tr key={p.person_id}>
                <td className="left">{p.display_name}</td>
                <td className="left">
                  <input
                    type="text"
                    placeholder="—"
                    defaultValue={p.email ?? ""}
                    onBlur={(e) =>
                      e.target.value !== (p.email ?? "") &&
                      run(() => api.patchPerson(p.person_id, { email: e.target.value }))
                    }
                  />
                </td>
                <td className="num">{p.services_owned}</td>
                <td className="num">{p.assets_owned}</td>
                <td className="num">{p.tasks_owned}</td>
                <td>
                  {canDelete && p.services_owned + p.assets_owned + p.tasks_owned === 0 && (
                    <button
                      className="linkbtn"
                      onClick={() =>
                        run(() => api.removePerson(p.person_id))
                      }
                    >
                      delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="row" style={{ marginTop: 12 }}>
        <input
          type="text"
          placeholder="add a person…"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button
          className="btn"
          disabled={!name.trim()}
          onClick={() => {
            const text = name.trim();
            setName("");
            void run(() => api.addPerson(text));
          }}
        >
          Add
        </button>
      </div>
      <p className="note">
        Email becomes the join key when Google sign-in is switched on, so a person without one
        will not be able to be granted access until it is filled in.
      </p>
    </Panel>
  );
}
